import styled from "styled-components"

const ResourceCard = styled.div`
  overflow: clip;
  border-radius: ${({ theme }) => theme.borders.softRadius};
  box-shadow: 0px 0px 4px 0px rgba(119, 119, 119, 0.25);
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;

  & > :last-child {
    flex-grow: 1;
  }
`

export default ResourceCard
